import { Component, Input, Output } from '@angular/core';
import { Entity, RelatedEntity } from '@app/core/model/entities/entity';
import {
  MatSelectAutocompleteComponent
} from '@app/shared/components/mat-select-autocomplete/mat-select-autocomplete.component';

@Component({
  template: '',
  standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class MatSelectEntityAutocomplete<T extends RelatedEntity, E extends Entity> extends MatSelectAutocompleteComponent<T> {
  public displayWith = (entity: E | T): string => entity?.toString();

  // Entity to exclude from the search.
  @Input() public exclude: E;

  // Limit the search to those entityIds
  @Input() public allowedEntityIds: string[];

  // Whether there are suggestions to display
  @Output() public hasData: boolean = false;

  // Whether the component initialization has completed
  @Output() public ready: boolean = false;
}
